export default __webpack_public_path__ + "static/media/198.63099936.jpg";